import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";  // "" = same origin (/api)
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Подпись Telegram WebApp летит во все запросы мини-аппа — сервер проверяет
// её и берёт tg_id из подписи, а не из тела запроса.
api.interceptors.request.use((cfg) => {
  try {
    const idata = window.Telegram?.WebApp?.initData;
    if (!idata || !cfg.url) return cfg;
    const needs = cfg.url.startsWith("/public/app/")
      || cfg.url.startsWith("/public/landing/state")
      || cfg.url.startsWith("/public/landing/stream");
    if (!needs) return cfg;
    if ((cfg.method || "get").toLowerCase() === "get") {
      cfg.params = { ...(cfg.params || {}), init_data: idata };
    } else if (typeof FormData !== "undefined" && cfg.data instanceof FormData) {
      cfg.data.append("init_data", idata);
    } else if (cfg.data && typeof cfg.data === "object") {
      cfg.data = { ...cfg.data, init_data: idata };
    }
  } catch { /* noop */ }
  return cfg;
});

export function setAdminToken(token) {
  if (token) {
    api.defaults.headers.common["X-Admin-Token"] = token;
    localStorage.setItem("th_admin_token", token);
  } else {
    delete api.defaults.headers.common["X-Admin-Token"];
    localStorage.removeItem("th_admin_token");
  }
}

const saved = localStorage.getItem("th_admin_token");
if (saved) api.defaults.headers.common["X-Admin-Token"] = saved;
